const convertDollarStringToFloat = (dollarString: string): number => {
  return parseFloat(dollarString.replace('$', '').replace(/,/g, ''))
}

export default convertDollarStringToFloat
